<template lang="pug">
  .part.part-3
    //- .game__wave(style="display: flex; align-items: center; justify-content: center;")
    //-   p h5 動態
    .game__messages
      transition-group(name="fade" mode="out-in" tag="div")
        p(v-for="item, index in messages" v-html="item" v-show="currentMessage === index" :key="`game__messages-${index}`") 
    .game__hint
      p 讀取中... 請勿移開手指喔~
    //- .game__button.game__button-recording
    //-   .game__button__score
    //-     span.game__button__number 88
    //-     span.game__button__unit 次 / 分
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'GamePart3',
  props: {
    changePart: Function,
    toggleBpm: Function,
    bpm: Number,
  },
  data: () => {
    return {
      totalDuration: 10000,
      messages: [
        // '慢慢調整呼吸<br>感受內心的聲音',
        // '你的心跳想告訴你',
        // '認真時 每一次心跳加速<br>都代表你愛上了自己',
        '你用心跳 打出了節奏',
        '用呼吸 譜成了旋律',
        '倒數3秒…<br>心跳讀取完畢',
      ],
      currentMessage: 0,
      countdownTimer: null,
      completeTimer: null,
    }
  },
  computed: {
    ...mapState([])
  },
  methods: {
    ...mapActions(['saveAuthor']),
    startCountdown() {
      const { totalDuration, saveAuthor, changePart, toggleBpm } = this;
      const { length } = this.messages;
      clearInterval(this.countdownTimer);
      this.countdownTimer = setInterval(() => {
        this.currentMessage++;
        if (this.currentMessage >= 1) toggleBpm(true);
        if (this.currentMessage === length - 1) {
          clearInterval(this.countdownTimer);
          this.completeTimer = setTimeout(() => {
            saveAuthor({ bpm: this.bpm });
            changePart(4);
          }, 3000);
        }
      }, (totalDuration - 3000) / (length - 1));
    },
  },
  mounted() {
    const { startCountdown } = this;
    startCountdown();
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/game/part-3/';

#game .part-3 {

  .game__messages {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: vw(559);
    left: 0;
    width: 100%;
    height: vw(126);

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }

    p {
      position: absolute;
      left: 0;
      width: 100%;
      font-size: vw(30);
      text-align: center;
      line-height: lineHeight(30, 48);
      letter-spacing: vw(letterSpacing(500, 30));
      padding-left: vw(letterSpacing(500, 30));
      @include narrow-text;
      @include neon-text;
    }
  }

  .game__button__score {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #ec4c3b;
    z-index: -1;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    span {
      text-indent: 0;
      letter-spacing: 0;
    }

    .game__button__number {
      font-size: vw(65);
      font-weight: 500;
      line-height: 1;
      letter-spacing: vw(letterSpacing(100, 65));
      padding-left: vw(letterSpacing(100, 65));
    }

    .game__button__unit {
      font-size: vw(27);
      letter-spacing: vw(letterSpacing(200, 27));
      padding-top: vw(20);
      padding-bottom: vw(10);
      padding-left: vw(letterSpacing(200, 27));
    }
  }

  .game__hint {
    position: absolute;
    top: vw(1092);
    left: 0;
    width: 100%;
    p {
      font-size: vw(26);
      text-align: center;
      letter-spacing: vw(letterSpacing(400, 26));
      @include narrow-text;
    }
  }

}

</style>
